import React from 'react';
import styled from '@emotion/styled';

export const innerWrap = {
  backgroundColor: '#fff',
  boxShadow: '0 21px 73px -6px rgba(19, 21, 50, 0.09)',
  margin: '0 auto',
  padding: '84px 0 40px 32px',
  position: 'relative',
  width: 327,
  zIndex: 100,
  '@media(min-width: 768px)': {
    marginLeft: 94,
  },
  '@media(min-width: 1024px)': {
    marginLeft: 70,
  },
  '@media(min-width: 1260px)': {
    padding: '65px 0 25px 32px',
    width: 445,
  },
};
export const wrapper = {
  position: 'relative',
  zIndex: '75',
  '@media(min-width: 768px)': {
    marginTop: 300,
  },
  '@media(min-width: 1024px)': {
    marginTop: 87,
  },
  '@media(min-width: 1260px)': {
    marginTop: 118,
  },
};

export const testimonialOverrides = {
  position: 'relative',
  bottom: 160,
  zIndex: '100',
  '@media(min-width: 1023px)': { display: 'none' },
};

export const quote = {
  fontSize: 18,
  lineHeight: 1.56,
  maxWidth: 275,
  '@media(min-width: 1260px)': {
    maxWidth: 350,
  },
};
export const imageStyles = {
  borderRadius: '50%',
  height: 104,
  left: 32,
  overflow: 'hidden',
  position: 'absolute',
  top: -50,
  width: 104,
  zIndex: 50,
  '@media(min-width: 1260px)': {
    left: 40,
  },
};
export const smallLine = {
  borderTop: '1px solid #d8d8d8',
  left: -32,
  position: 'absolute',
  top: 16,
  width: 16,
};
export const bigLine = {
  borderTop: '1px solid #d8d8d8',
  position: 'absolute',
  right: 0,
  top: 16,
  width: 119,
  '@media(min-width: 1260px)': {
    width: 220,
  },
};
export const logoStyles = {
  marginTop: 16,
  maxWidth: 264,
};
export const textWrap = {
  fontSize: 24,
  marginBottom: 42,
  maxWidth: 237,
  '@media(min-width: 768px)': {
    display: 'flex',
    fontSize: 32,
    maxWidth: 559,
  },
  '@media(min-width: 1024px)': {
    marginTop: 218,
  },
  '@media(min-width: 1260px)': {
    fontSize: 48,
    marginTop: 131,
    maxWidth: 563,
  },
};
export const iconStyles = {
  alignItems: 'center',
  display: 'flex',
  fontSize: 18,
};
export const circleStyles = {
  backgroundColor: '##D8D8D8',
  height: 857,
  position: 'absolute',
  top: 150,
  width: 375,
  zIndex: 55,
};
export const outerOffices = {
  display: 'flex',
  flexWrap: 'wrap',
  marginTop: 90,
  '@media(min-width: 768px)': {
    marginLeft: 32,
    marginTop: 16,
  },
  '@media(min-width: 1024px)': {
    marginBottom: 40,
  },
  '@media(min-width: 1260px)': {
    marginLeft: 170,
    marginTop: 0,
    maxWidth: 730,
    zIndex: 60,
  },
};
export const offices = {
  fontSize: 18,
  fontWeight: 'bold',
  maxWidth: 144,
  '@media(min-width: 1260px)': {
    fontSize: 24,
    maxWidth: 239,
  },
};
export const mapStyles = {
  bottom: 65,
  position: 'relative',
  zIndex: 202,
  '@media(min-width: 768px)': {
    bottom: 100,
    left: -252,
    maxWidth: 600,
    position: 'absolute',
    width: '100%',
    zIndex: 15555,
  },
  '@media(min-width: 1024px)': {
    bottom: 24,
  },
  '@media(min-width: 1260px)': {
    left: 37,
    zIndex: 60,
  },
  '@media(min-width: 1440px)': { bottom: 40, maxWidth: 797 },
};

export const branchWrap = {
  marginTop: 40,
  '@media(min-width: 1024px)': { marginRight: 29 },
};

export const addressStyles = {
  width: 160,
  marginTop: 16,
  lineHeight: 2,
  '@media(min-width: 768px)': {
    width: 176,
  },
  '@media(min-width: 1260px)': { fontSize: 16 },
};

export const lovetohearMessage = {
  position: 'relative',
  top: -60,
  padding: '0px 24px',
  zIndex: '68',
  '@media(min-width: 768px)': { paddingLeft: 94 },
  '@media(min-width: 1024px)': { top: 0 },
  '@media(min-width: 1440px)': { paddingLeft: 415, top: 0 },
};

export const contactDetailStyles = {
  '@media(min-width: 768px)': { display: 'flex', alignItems: 'flex-start' },
  '@media(min-width: 1260px)': { marginTop: 92 },
};

export const goodCompany = {
  lineHeight: 2.29,
  marginTop: 32,
  '@media(min-width: 1260px)': {
    marginTop: 28,
  },
};

export const clientImagesWrap = {
  img: { marginRight: 40, filter: 'grayscale(100%)', maxWidth: 55, opacity: 0.5, paddingTop: 10 },
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
};

export const FBSuccessWrap = styled.div`
  background-color: #F6F6F6;
  position: relative;
  .fbbgc {
    overflow: hidden;
    svg {
      position: absolute;
      top: 0px;
      width: auto;
      height: 100%;
      :first-of-type {
        width: 100%;
        height: auto;
      }
      :last-of-type {
        width: 152px;
        height: auto;
        right: 16px;
        top: -60px;
      }
    }
  }
  .fbWrap {
    padding: 80px 22px;
    min-height: 720px;
    z-index: 100;
    position: relative;
  }
  .fb-contact {
    color: #000;
    text-align: center;
    font-family: Syne;
    font-size: 44px;
    font-weight: 300;
    line-height: 48px; /* 109.091% */
  }
  .fb-floating-box {
    background-color: #fff;
    box-shadow: 0px 16px 32px 0px rgba(0, 0, 0, 0.10);
    padding: 74px 24px 80px;
    margin: 70px auto 0;
    position: relative;
    text-align: center;
    .fb-check-circle {
      position: absolute;
      top: -24px;
      width: 70px;
      height: auto;
      left: 50%;
      transform: translateX(-50%);
    }
  }
  .fb-thankee {
    font-size: 33px;
    color: #000 ;
    font-family: Syne;
    line-height: 40px;
    text-align: center;
  }
  .fb-be-back {
    font-size: 17px;
    font-family: Ubuntu;
    font-weight: 500;
    line-height: 147%;
    margin-top: 48px;
    text-align: center;
  }
  a {
    display: inline-block;
    margin: 48px auto 0;
  }
  .fb-home {
    display: inline-flex;
    width: auto;
    padding-left: 24px;
    text-transform: lowercase;
  }
  @media (min-width: 768px) {
    .fb-floating-box {
      max-width: 500px;
    }
  }
  @media (min-width: 1024px) {
    .fb-floating-box {
      max-width: 830px;
    } 
    .fbbgc {
      svg {
        :last-of-type {
          top: -80px;
          width: 250px;
          right: 96px;

        }
      }
    }
    .fbWrap {
      padding: 157px 96px 150px;
    }
    .fb-contact {
      font-size: 84px;
    }
    .fb-floating-box {
      margin-top: 118px;
      padding: 132px 113px 102px;
      .fb-check-circle {
        width: 90px;
        height: auto;
        top: -32px;
      }
    }
    .fb-thankee {
      font-size: 40px;
      line-height: 48px;
    }
    .fb-be-back {
      font-size: 24px;
      line-height: 32px;
      margin-top: 40px;
    }
    a {
      margin-top: 62px;
    }
    .fb-home {
      height: 64px;
      font-size: 14px;
      text-transform: uppercase;
      padding-left: 44px;
      padding-right: 20px;
      margin-top: 0;
    }
  }
  @media (min-width: 1920px) {
    .fbbgc {
      svg {
        :last-of-type {
          top: -120px;
          right: 200px;
          width: 358px;
        }
      }
    }
    .fbWrap {
      padding: 192px 96px 163px;
    }
    .fb-contact {
      text-align: left;
      max-width: 1110px;
      margin: 0 auto;
    }
    .fb-floating-box {
      margin-top: 130px;
      padding: 132px 250px 102px;
      max-width: 1110px;
      > svg {
        width: 62px;
        height: 62px;
        top: -32px;
      }
    }
    .fb-home {
      height: 64px;
      font-size: 14px;
      text-transform: uppercase;
      padding-left: 44px;
      padding-right: 20px;
    }
  }
`;

export const FBLowerSection = styled.div`
  position: relative;
  overflow: hidden;
  .fb-contact {
    top: 0;
    padding-top: 40px;
  }
  @media (min-width: 1024px) {
    padding-bottom: 80px;
    .fb-contact {
      padding-top: 0px;
    }
    .fb-textWrap {
      margin-top: 80px;
    }
  }
`;

export function FbBackground({ ...props }) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='390'
      height='349'
      viewBox='0 0 390 349'
      fill='none'
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M0 0.66539H390V374.583H0V0.66539Z'
        fill='url(#paint0_linear_13_928)'
      />
      <defs>
        <linearGradient
          id='paint0_linear_13_928'
          x1='591.174'
          y1='505.105'
          x2='775.192'
          y2='19.0807'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#E5E5FA' stopOpacity='0.01' />
          <stop offset='1' stopColor='#C6C6F3' />
        </linearGradient>
      </defs>
    </svg>
  );
}

export function FBMotif({ ...props }) {
  return (
    <svg
      width='154'
      height='150'
      viewBox='0 0 154 150'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M153.209 -75.9546L9.05557 -75.9546L22.0688 -87.8898L22.1421 -87.959V-108.625H131.427V-88.0358H145.549V-118.992L8.01994 -119V-65.5794L144.523 -65.5794L131.5 -53.4904L131.427 -53.4212L123.767 -32.9476L45.3622 -36.1762L22.1421 -53.9515H8.01994L8.01994 -22.5724H0.359985V-10.4143V91.7071L123.808 137.799V149.357H153.24L153.209 -75.9546ZM71.3277 -16.3544L63.6395 -16.286L63.6395 88.2874L32.0744 76.9684L32.0744 -28.3178H84.1187L71.3277 -16.3544ZM123.046 -16.2495L122.974 -16.1804L122.974 108.322L122.984 110.225L91.4377 98.3187L91.4377 -26.9467L143.482 -28.3177L123.046 -16.2495Z'
        fill='white'
      />
    </svg>
  );
}

export function CheckCircleTwo() {
  return (
    <svg width='78' height='87' viewBox='0 0 78 87' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g filter='url(#filter0_d_13_939)'>
        <circle cx='39' cy='24' r='24' fill='#55DCAC' />
      </g>
      <path
        d='M29.1638 23.3832L36.2298 32.2991L49.3549 15.7377'
        stroke='white'
        strokeWidth='3'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <defs>
        <filter
          id='filter0_d_13_939'
          x='0'
          y='0'
          width='78'
          height='87'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood flood-opacity='0' result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feMorphology
            radius='15'
            operator='erode'
            in='SourceAlpha'
            result='effect1_dropShadow_13_939'
          />
          <feOffset dy='24' />
          <feGaussianBlur stdDeviation='15' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0.486275 0 0 0 0 0.85098 0 0 0 0 0.686275 0 0 0 0.908599 0'
          />
          <feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_13_939' />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect1_dropShadow_13_939'
            result='shape'
          />
        </filter>
      </defs>
    </svg>
  );
}
